export function obterListaMdfeModeloDocFiscal() {
  return (
    [
      { label: 'CTE', value: '57' },
      { label: 'NFE', value: '55' },
    ]
  );
}
